import React from 'react';

const Unauthorized = () => {
  return (
    <>
      <div className="page d-flex flex-column justify-content-center align-items-center vh-100">
        <h1 className="display-4">Acesso Não Autorizado</h1>
        <p className="lead">Você não está autorizado a acessar esta página. Por favor, verifique com o administrador do sistema.</p>
      </div>
    </>
  );
};

export default Unauthorized;
